// slideUp
const slideUp = (el, duration = 300) => {
  el.style.height = el.offsetHeight + "px";
  el.offsetHeight;
  el.style.transitionProperty = "height, margin, padding";
  el.style.transitionDuration = duration + "ms";
  el.style.transitionTimingFunction = "ease";
  el.style.overflow = "hidden";
  el.style.height = 0;
  el.style.paddingTop = 0;
  el.style.paddingBottom = 0;
  el.style.marginTop = 0;
  el.style.marginBottom = 0;
  setTimeout(() => {
    el.style.display = "none";
    el.style.removeProperty("height");
    el.style.removeProperty("padding-top");
    el.style.removeProperty("padding-bottom");
    el.style.removeProperty("margin-top");
    el.style.removeProperty("margin-bottom");
    el.style.removeProperty("overflow");
    el.style.removeProperty("transition-duration");
    el.style.removeProperty("transition-property");
    el.style.removeProperty("transition-timing-function");
  }, duration);
};

// slideDown
const slideDown = (el, duration = 300) => {
  el.style.removeProperty("display");
  let display = window.getComputedStyle(el).display;
  if (display === "none") {
    display = "block";
  }
  el.style.display = display;
  let height = el.offsetHeight;
  el.style.overflow = "hidden";
  el.style.height = 0;
  el.style.paddingTop = 0;
  el.style.paddingBottom = 0;
  el.style.marginTop = 0;
  el.style.marginBottom = 0;
  el.offsetHeight;
  el.style.transitionProperty = "height, margin, padding";
  el.style.transitionDuration = duration + "ms";
  el.style.transitionTimingFunction = "ease";
  el.style.height = height + "px";
  el.style.removeProperty("padding-top");
  el.style.removeProperty("padding-bottom");
  el.style.removeProperty("margin-top");
  el.style.removeProperty("margin-bottom");
  setTimeout(() => {
    el.style.removeProperty("height");
    el.style.removeProperty("overflow");
    el.style.removeProperty("transition-duration");
    el.style.removeProperty("transition-property");
    el.style.removeProperty("transition-timing-function");
  }, duration);
};

// コンテンツ表示切り替え
const navBtns = document.getElementsByClassName("faq-nav__switch");
const sections = document.getElementsByClassName("accordion__wrapper");
Array.from(navBtns).forEach((navBtn) => {
  navBtn.addEventListener("click", () => {
    const targetSection = `section-${navBtn.id}`;
    Array.from(sections).forEach((section) => {
      if (section.id === targetSection) {
        if (section.classList.contains("hide")) {
          section.classList.remove("hide");
        }
      } else {
        if (!section.classList.contains("hide")) {
          section.classList.add("hide");
        }
      }
    });
  });
});

// slideToggle
const slideToggle = (el, duration = 300) => {
  if (window.getComputedStyle(el).display === "none") {
    return slideDown(el, duration);
  } else {
    return slideUp(el, duration);
  }
};

const ac_header_list = document.getElementsByClassName("ac_header");
Array.from(ac_header_list).forEach((ac_header) => {
  ac_header.addEventListener("click", () => {
    if (!ac_header.classList.contains("open")) {
      ac_header.classList.add("open");
      ac_header.nextElementSibling.classList.add("open");
      slideToggle(ac_header.nextElementSibling, 300);
    } else {
      slideToggle(ac_header.nextElementSibling, 300);
      ac_header.classList.remove("open");
      ac_header.nextElementSibling.classList.remove("open");
    }
  });
});

//タブ切り替え
$('.js-faq-tab').on('click', function() {
  $('.js-faq-tab, .js-faq-list').removeClass('active');

  $(this).addClass('active');

  var index = $('.js-faq-tab').index(this);
  $('.js-faq-list').eq(index).addClass('active');
});
